import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  async lookup(event) {
    const input = event.currentTarget
    const row = input.closest("[data-sca-code-row]")
    const description = row?.querySelector("[data-sca-code-description]")
    if (!description) return

    description.textContent = ""
    description.id = ""
    if (!input.value.trim()) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    if (!csrfToken) return

    description.id = `sca-code-description-${crypto.randomUUID()}`

    // Send the clinical code in a POST body, never a URL, so it stays out of
    // access/proxy logs; Rails additionally filters the clinical_code param.
    const body = new URLSearchParams()
    body.set("kind", input.dataset.scaCodeKind)
    body.set("clinical_code", input.value)
    body.set("target_id", description.id)

    const headers = {
      Accept: "text/vnd.turbo-stream.html",
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRF-Token": csrfToken
    }

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        credentials: "same-origin",
        headers,
        body
      })
      if (response.ok) Turbo.renderStreamMessage(await response.text())
    } catch {
      // Description lookups are optional; explicit Price/Reprice remains authoritative.
    }
  }
}
